import { isEqual } from "lodash-es";

import { Presence } from "api/generated/model";

export function diffToPresence<T extends string | number>(
    source: Set<T>,
    update: Set<T>
): Record<T, Presence> {
    const diff: Record<T, Presence> = {} as Record<T, Presence>;

    for (const sourceKey of source) {
        if (!update.has(sourceKey)) {
            diff[sourceKey] = "Absent";
        }
    }

    for (const updateKey of update) {
        if (!source.has(updateKey)) {
            diff[updateKey] = "Present";
        }
    }

    return diff;
}

export function getIfChanged<T>(source: T, update: T): T | undefined {
    if (isEqual(source, update)) {
        return undefined;
    } else {
        return update;
    }
}
